const validationMixin = {
  methods: {
    validate () {
      this.$v.$touch()
      // if its still pending or an error is returned do not submit
      if (this.$v.$pending || this.$v.$error) return false
      return true
    },
    resetValidation () {
      this.$v.$reset()
    }
  }
}

export default validationMixin
